<template>
  <div class="vx-notfound">
    <div class="container text-center">
      <img src="../assets/images/not-found.svg" height="200">
      <h6>Data tidak ditemukan</h6>
    </div>
  </div>
</template>

<style lang="stylus">
  .vx-notfound {
    position: relative;
  }

  .container {
    position : absolute;
    top: 50%;
    left: 50%;
    transform : translate(-50%, -50%)

    img {
      margin: 0 auto;
    }
  }
</style>

<script>
export default{
  name: 'vx-notfound'
}
</script>
